// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Okra","input":"styles_input__1_KKN"};